import { Alert } from "antd";
import type React from "react";
import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";
import { dismissBanner } from "../../slices/bannerSlice";

const BannerStack: React.FC = () => {
  const banners = useAppSelector((state) => state.banner.banners);
  const dispatch = useAppDispatch();
  const containerRef = useRef<HTMLDivElement | null>(null);

  // Publish rendered height as --banner-height so viewport-sized regions
  // (calc(100dvh - 64px - var(--banner-height))) reserve space.
  useEffect(() => {
    const el = containerRef.current;
    const root = document.documentElement;
    if (!el || banners.length === 0) {
      root.style.setProperty("--banner-height", "0px");
      return;
    }
    const publish = () => {
      root.style.setProperty("--banner-height", `${el.offsetHeight}px`);
    };
    publish();
    const ro = new ResizeObserver(publish);
    ro.observe(el);
    return () => {
      ro.disconnect();
      root.style.setProperty("--banner-height", "0px");
    };
  }, [banners.length]);

  if (banners.length === 0) return null;

  return (
    <div ref={containerRef} style={{ flex: "0 0 auto" }}>
      {banners.map((banner) => (
        <Alert
          key={banner.id}
          message={banner.message}
          type={banner.type}
          banner
          closable={banner.closable ?? true}
          onClose={() => dispatch(dismissBanner(banner.id))}
          style={{ justifyContent: "flex-start", textAlign: "left" }}
        />
      ))}
    </div>
  );
};

export default BannerStack;
